/**
 * The one theme precedence rule: `?background=` (share and embed links) beats the
 * stored preference. themePreference.ejs repeats it because it runs before any
 * bundle — keep that copy in step.
 */
export function resolveTheme({ urlBackground, storedBackground }) {
    if (urlBackground) return urlBackground
    return storedBackground === 'dark' ? 'dark' : 'light'
}
